export default __webpack_public_path__ + "7fe0bfaed10c0d7bb1fd52315920ac6b.webp";